import { createSlice } from "@reduxjs/toolkit";
import { FULLFILLED } from "@root/constants";
import { AUTH_LOGIN, AUTH_LOGOUT } from "@root/store/action-types";
import {
  USER_PROFILE,
  UPDATE_TOUR_COMPLETION,
  FETCH_TOUR_GUIDES,
} from "@root/store/action-types/userProfile";

const INITIAL_STATE: IAuthEntities & { tourGuidesLoading?: boolean } = {
  data: null,
  givenEmailForPasswordRecovery: {
    email: "test@gmail.com",
  },
  avatar: "",
  profile: {},
  tourGuidesLoading: false,
};

export const authEntitySlice = createSlice({
  name: "auth",
  initialState: INITIAL_STATE,
  reducers: {
    resetAuthData: (state) => {
      state.data = null;
    },
    setAuthData: (state, action) => {
      state.data = action.payload;
    },
    updatePasswordRecoverEmail: (state, action) => {
      state.givenEmailForPasswordRecovery = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(`${AUTH_LOGIN}${FULLFILLED}`, (state, action: any) => {
      const { token, ...rest } = action.payload;
      state.data = rest?.user;
    });
    builder.addCase(`${AUTH_LOGOUT}${FULLFILLED}`, (state) => {
      state.data = null;
    });
    builder.addCase(`${USER_PROFILE}${FULLFILLED}`, (state, action: any) => {
      state.data = action?.payload;
    });
    builder.addCase(
      `${FETCH_TOUR_GUIDES}${FULLFILLED}`,
      (state, action: any) => {
        const tourGuides = action?.payload?.tourGuides as
          | Array<{ type: number; isDone: boolean }>
          | undefined;
        state.tourGuidesLoading = false;
        if (!state.data || !Array.isArray(tourGuides)) return;
        (state.data as any) = {
          ...state.data,
          tourGuides,
        };
      },
    );
    builder.addCase(`${FETCH_TOUR_GUIDES}/pending`, (state) => {
      state.tourGuidesLoading = true;
    });
    builder.addCase(`${FETCH_TOUR_GUIDES}/rejected`, (state) => {
      state.tourGuidesLoading = false;
    });
    builder.addCase(
      `${UPDATE_TOUR_COMPLETION}${FULLFILLED}`,
      (state, action: any) => {
        const incoming = action?.payload?.tourData?.tourGuides as
          | Array<{ type: number; isDone: boolean }>
          | undefined;
        if (!incoming?.length || !state.data) return;
        const prev = (state.data as any).tourGuides ?? [];
        const byType = new Map(prev.map((t: any) => [t.type, t]));
        incoming.forEach((t) => byType.set(t.type, t));
        (state.data as any) = {
          ...state.data,
          tourGuides: Array.from(byType.values()),
        };
      },
    );
    // builder.addCase(`${GET_PROFILE}${FULLFILLED}`, (state, action: any) => {
    //   state.profile = action?.payload;
    // });
  },
});

export const { resetAuthData, setAuthData, updatePasswordRecoverEmail } =
  authEntitySlice.actions;

export const authEntityReducer = authEntitySlice.reducer;
